<div class="grey-background w-100 h-100">

  <div class="container container-centered-page">
    <div class="row w-100 login-row">

      <div class="col-3 d-none d-md-block"></div>

      <div class="col-12 col-md-6">
        <div class="text-center mb-4">
          <a routerLink="/"><img src="assets/logo.png" class="logo-centered"></a>
        </div>

        <div class="login-box">
          <ng-content></ng-content>
        </div>

        <div class="login-footer">
          <div class="copyright-info">Copyright © 2026 Alegra Learning</div>
          <app-version-number [absolutePlacement]="true"></app-version-number>
        </div>
      </div>

      <div class="col-3 d-none d-md-block"></div>

    </div>
  </div>

</div>
